import styled from 'styled-components';
import { variant } from 'styled-system';
import { BaseButton } from './BaseButton';
import { getSemanticValue } from '../../utils/cssVariables';
const variantStyles = variant({
    variants: {
        default: {
            color: getSemanticValue('foreground-accent-default'),
            fill: getSemanticValue('foreground-accent-default'),
            '&:hover': {
                color: getSemanticValue('foreground-accent-emphasized'),
                fill: getSemanticValue('foreground-accent-emphasized')
            },
            '&:disabled': {
                color: getSemanticValue('foreground-disabled'),
                fill: getSemanticValue('foreground-disabled')
            }
        },
        danger: {
            color: getSemanticValue('foreground-danger-default'),
            fill: getSemanticValue('foreground-danger-default'),
            '&:hover': {
                color: getSemanticValue('foreground-danger-emphasized'),
                fill: getSemanticValue('foreground-danger-emphasized')
            },
            '&:disabled': {
                color: getSemanticValue('foreground-disabled'),
                fill: getSemanticValue('foreground-disabled')
            }
        }
    }
});
const TextButton = styled(BaseButton).withConfig({ displayName: "TextButton", componentId: "sc-1oojk2j" }) `
    transition: color 200ms, fill 200ms;

    ${variantStyles};
`;
TextButton.defaultProps = {
    size: 'medium',
    variant: 'default'
};
export { TextButton };
